import { render, staticRenderFns } from "./CatBanner.vue?vue&type=template&id=6dd67b17&"
import script from "./CatBanner.vue?vue&type=script&lang=js&"
export * from "./CatBanner.vue?vue&type=script&lang=js&"
import style0 from "./CatBanner.vue?vue&type=style&index=0&id=6dd67b17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports